<template>
  <button
    :type="type"
    :disabled="disabled"
    v-on="$listeners"
  >
    <component
      :is="hasLink ? linkComponent : 'span'"
      :class="clsx('orange-fancy-button', { 'orange-fancy-button--disabled': disabled })"
      v-bind="hasLink ? linkProps : {}"
    >
      <span class="button-content">
        <slot />
        <span class="icon-wrapper">
          <span class="arrow-track">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_8000_14421)">
                <path d="M13 18L17.4665 12.6402C17.7216 12.3341 17.8491 12.181 17.8491 12C17.8491 11.819 17.7216 11.6659 17.4665 11.3598L13 6" stroke="#EB883B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 18L10.4665 12.6402C10.7216 12.3341 10.8491 12.181 10.8491 12C10.8491 11.819 10.7216 11.6659 10.4665 11.3598L6 6" stroke="#EB883B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_8000_14421">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>

            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_8000_14422)">
                <path d="M13 18L17.4665 12.6402C17.7216 12.3341 17.8491 12.181 17.8491 12C17.8491 11.819 17.7216 11.6659 17.4665 11.3598L13 6" stroke="#EB883B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 18L10.4665 12.6402C10.7216 12.3341 10.8491 12.181 10.8491 12C10.8491 11.819 10.7216 11.6659 10.4665 11.3598L6 6" stroke="#EB883B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_8000_14422">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>
        </span>
      </span>
    </component>
  </button>
</template>

<script>
import clsx from 'clsx';
import { HashAnchor, SmartLink } from '@/shared/ui/link';

export default {
  props: {
    type: {
      type: String,
      default: 'button',
      validator(value) { return ['button', 'submit', 'reset'].includes(value); },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_self',
      validator(value) { return ['_blank', '_self', '_parent', '_top'].includes(value); },
    },
    method: {
      type: Function,
      default: null,
    },
    event: {
      type: String,
      default: null,
    },
    hash: {
      type: String,
      default: null,
    },
  },
  methods: { clsx },
  components: { SmartLink, HashAnchor },
  computed: {
    hasLink() {
      return this.url || this.route || this.hash;
    },
    linkComponent() {
      if (this.hash && !this.url && !this.route) {
        return 'HashAnchor';
      }

      return 'SmartLink';
    },
    linkProps() {
      const props = {
        disabled: this.disabled,
      };
      if (this.linkComponent === 'HashAnchor') {
        return {
          ...props,
          hash: this.hash,
        };
      } else {
        return {
          ...props,
          url: this.url,
          route: this.route,
          target: this.target,
          method: this.method,
          event: this.event,
          hash: this.hash,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.orange-fancy-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #F6AB6F 0%, #EB883B 100%);
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #FFFFFF;
  border-radius: 16px;
  padding: 16px 24px;
  width: 100%;
  transition: background 0.3s ease;

  &:hover:not(.orange-fancy-button--disabled) {
    background: linear-gradient(90deg, #e59455 0%, #d67020 100%);

    & .icon-wrapper .arrow-track {
      animation: scrollArrows 0.8s linear 1 forwards;
    }
  }

  .button-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .icon-wrapper {
    display: flex;
    position: relative;
    width: 30px;
    height: 30px;
    min-width: 30px;
    background-color: #FFFFFF;
    border-radius: 50%;
    overflow: hidden;

    .arrow-track {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: -3px;
      bottom: 0;
      width: 200%;
      transition: transform 0.3s ease;
    }
  }
}

@keyframes scrollArrows {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0%);
  }
}

.orange-fancy-button--disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
